import {AccessModel} from '../../../models/api/accessModel';
import {AppAction} from '../../appActions';
import {DataGroupsActionsEnum} from '../dataGroupsActions';

export function accessReducer(state: AccessModel, action: AppAction): AccessModel {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED:
      return action.payload.result.access || state;

    default:
      return state;
  }
}
